import React, { useRef } from 'react';
var VeltCommentDialogCopyLink = function (props) {
    var annotationId = props.annotationId, defaultCondition = props.defaultCondition, inlineCommentSectionMode = props.inlineCommentSectionMode, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-dialog-copy-link", { ref: ref, "annotation-id": annotationId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "inline-comment-section-mode": [true, false].includes(inlineCommentSectionMode) ? (inlineCommentSectionMode ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentDialogCopyLink;
